import type { Step, Workflow } from './types.ts';

export const ROOT_SCOPE = '#root';

export interface Scope {
  id: string;
  repeat: Step | null;
  parent: Scope | null;
  locations: StepLocation[];
}

export interface StepLocation {
  step: Step;
  scope: Scope;
  index: number;
  number: number;
  sectionId: string;
}

export interface WorkflowIndex {
  root: Scope;
  scopes: Map<string, Scope>;
  byId: Map<string, StepLocation>;
  all: StepLocation[];
  duplicates: string[];
}

export function indexWorkflow(workflow: Workflow): WorkflowIndex {
  const root: Scope = { id: ROOT_SCOPE, repeat: null, parent: null, locations: [] };
  const index: WorkflowIndex = {
    root,
    scopes: new Map([[ROOT_SCOPE, root]]),
    byId: new Map(),
    all: [],
    duplicates: [],
  };
  const visit = (step: Step, scope: Scope, sectionId: string): void => {
    const location: StepLocation = {
      step,
      scope,
      index: scope.locations.length,
      number: index.all.length + 1,
      sectionId,
    };
    scope.locations.push(location);
    index.all.push(location);
    if (index.byId.has(step.id)) {
      if (!index.duplicates.includes(step.id)) index.duplicates.push(step.id);
    } else {
      index.byId.set(step.id, location);
    }
    if (step.type === 'flow.repeat') {
      const body: Scope = { id: step.id, repeat: step, parent: scope, locations: [] };
      if (!index.scopes.has(step.id)) index.scopes.set(step.id, body);
      for (const child of step.steps ?? []) visit(child, body, sectionId);
    }
  };
  for (const section of workflow.sections) for (const step of section.steps) visit(step, root, section.id);
  return index;
}
